(function ($) {
    "use strict";

    const assetId = '~/theme/v1/Views/Document/ViewDocumentTemplatedContactForm.min.js';

    if (!window.umwAssets?.[assetId]) {
        console.error(`No context found for ${assetId}`);
        return;
    }

    for (const ctx of window.umwAssets[assetId]) {
        var feedbackControl = $('.js-feedback-control'); //page builder css wrapper for uc129 Feedback control
        var buttonFeedbackControl = $('#' + ctx.mainPanelId).find('.button-modal-form-btn');
        if (feedbackControl && buttonFeedbackControl) {
            buttonFeedbackControl.on('click', function () {
                $.fancybox.open({
                    parentEl: "form:first",
                    src: feedbackControl,
                    type: 'inline'
                });
            });
        }
    }
}(jQuery));